<template>
    <div class="configuration-overview d-none d-lg-block" :class="{'sticky-top': isSticky}">
      <div class="card card-body shadow">
        <form id="wnmProductConfigurationOverview" method="POST" target="_self">
          <div class="d-flex configuration-overview-header justify-content-between">
            <h5 class="configuration-overview-title mb-0">Ihre Konfiguration</h5>
          </div>

          <table class="configuration-overview-table">
            <tr
                class="configuration-overview-table-row"
                v-for="configuredItem in configuredItems"
                :key="configuredItem.id"
            >
              <td v-if="configuredItem.quantity"
                  class="configuration-overview-table-col align-items-center"
                  v-html="configuredItem.quantity + 'x ' + configuredItem.name">
              </td>
              <td v-else
                  class="configuration-overview-table-col align-items-center"
                  v-html="configuredItem.name">
              </td>
              <td class="configuration-overview-table-col">
                <div class="d-flex flex-column">
                  <span v-if="configuredItem.isArticle">{{ $filters.formatCurrency((configuredItem.netPrice * cartMultiplier).toFixed(2)) }}</span>
                  <span v-else>{{ $filters.formatCurrency((configuredItem.price * cartMultiplier).toFixed(2)) }}</span>
                  <span v-if="configuredItem.price > configuredItem.basePrice">({{$filters.formatCurrency(configuredItem.basePrice.toFixed(2))}})</span>
                </div>
              </td>

            </tr>
          </table>

          <StockDeliveryStatus />

          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex flex-column configuration-overview-cartMultiplier-wrapper mr-3" v-if="article.price > 0">
              <input
                  class="configuration-overview-cartMultiplier"
                  type="number"
                  v-model="cartMultiplier"
                  min="1"
              />
              <span><small>Menge</small></span>
            </div>

            <div class="d-flex" :class="{
            'flex-column': article.price > 0,
            'w-100 justify-content-center': article.price === 0,
          }">
              <span class="font-size-2x font-weight-bold" v-if="article.price > 0">ab {{ $filters.formatCurrency(totalPrice.toFixed(2)) }}</span>
              <small v-if="article.price > 0">Basispreis exkl. 19% USt.</small>
              <span class="font-size-1.5x font-weight-bold" v-if="article.price === 0">Preis auf Anfrage</span>
            </div>
          </div>

          <div class="d-flex justify-content-around mt-3">
            <button type="submit" class="submit btn add-to-cart-button px-4" v-if="article.price > 0">
              <span>zum Warenkorb </span><CartPlus/>
            </button>
          </div>

          <!-- form fields -->
          <input type="hidden" name="a" :value="article.id"/>
          <input type="hidden" name="anzahl" :value="cartMultiplier"/>

          <input type="hidden" name="wke" value="1"/>
          <input type="hidden" name="inWarenkorb" value="1"/>
          <input type="hidden" name="jtl_token" :value="jtlToken"/>
          <template v-for="configuredItem in configuredItems">

            <template v-if="!configuredItem.isArticle" :key="configuredItem.id">
              <input type="hidden" :name="`item[${configuredItem.configGroupId}][]`" :value="configuredItem.id"/>
              <input type="hidden" :name="`item_quantity[${configuredItem.id}]`" :value="configuredItem.quantity"/>
            </template>
          </template>
        </form>
      </div>
<!--      <SupportBox :is-sticky="true" />-->
    </div>

    <Teleport to="body" v-if="isMobile">
      <div class="visible-xs mobile position-fixed bg-white shadow" :class="{'mobile--open px-3 py-4': isOpen}">
        <div
            class="w-100 py-3 configuration-overview--controls"
        >
          <div v-if="!isOpen" class="d-flex justify-content-around">
            <div class="d-flex flex-column" v-if="article.price > 0">
              <span class="font-size-2x font-weight-bold">ab {{ $filters.formatCurrency(totalPrice.toFixed(2)) }}</span>
              <small>Basispreis inkl. 19% USt.</small>
            </div>
            <span class="d-flex align-items-center cursor-pointer" @click="isOpen = true">
            Konfiguration anfragen
            <i
                class="fa fa-2x fa-angle-up text-primary ml-2"
            ></i>
          </span>
          </div>
          <div v-if="isOpen">
            <div class="d-flex justify-content-around">
              <button @click="addToCart" class="submit btn add-to-cart-button px-4" v-if="article.price > 0">
                <span>zum Warenkorb </span><CartPlus/>
              </button>
            </div>
          </div>
        </div>
        <div
            v-if="isOpen"
            class="configuration-overview"
        >
          <div class="mb-3">
            <div>
              <div class="d-flex justify-content-between align-items-baseline">
                <h2>Ihre Konfiguration</h2>
                <span class="cursor-pointer text-primary font-size-3x" @click="isOpen = false">&times;</span>
              </div>
              <div
                  class="d-flex align-items-center"
                  @click="mobileHelpSectionOpen = !mobileHelpSectionOpen"
              >
                <span>Brauchen Sie hilfe?</span>
                <i
                    class="fa fa-2x fa-angle-up text-primary ml-2"
                    :class="{'rotate': mobileHelpSectionOpen}"
                ></i>
              </div>
              <div v-if="mobileHelpSectionOpen">
                <MobileExpertInfo />
              </div>
            </div>

          </div>
          <table class="configuration-overview-table configuration-overview-table--mobile w-100">
            <template
                v-for="(configuredItem, i) in configuredItems"
                :key="configuredItem.id"
            >
              <tr
                  class="configuration-overview-table-row"
              >
                <td class="configuration-overview-table-col">
                  <span v-if="!configuredItem.isArticle" class="mr-1">{{configuredItem.quantity}}x</span>
                  <span v-html="configuredItem.name"></span>
                </td>
                <td class="configuration-overview-table-col">
                  <div class="d-flex flex-column">
                    <span>{{ configuredItem.price > 0 ? $filters.formatCurrency((configuredItem.price * cartMultiplier).toFixed(2)): 'Preis auf Anfrage' }}</span>
                    <span v-if="configuredItem.price > configuredItem.basePrice">({{$filters.formatCurrency(configuredItem.basePrice.toFixed(2))}})</span>
                  </div>
                </td>
              </tr>
              <tr class="configuration-overview-table-row" v-if="!configuredItem.isArticle">
                <td>
                  <i class="fa fa-plus text-primary cursor-pointer mr-2" @click="increaseConfiguredItemQuantity(configuredItem)"></i>
                  <i class="fa fa-minus text-primary cursor-pointer" @click="decreaseConfiguredItemQuantity(configuredItem)"></i>
                </td>
              </tr>
              <tr v-if="i < configuredItems.length - 1">
                <td class="configuration-overview--separator" colspan="2"></td>
              </tr>
            </template>
          </table>

          <hr class="my-3">
          <StockDeliveryStatus />
          <hr class="my-3">

          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex flex-column configuration-overview-cartMultiplier-wrapper" v-if="article.price > 0">
              <input
                  class="configuration-overview-cartMultiplier"
                  type="number"
                  v-model="cartMultiplier"
                  min="1"
              />
              <span><small>Menge</small></span>
            </div>

            <div class="d-flex flex-column align-items-end">
              <span class="font-size-2x font-weight-bold" v-if="article.price > 0">ab {{ $filters.formatCurrency(totalPrice.toFixed(2)) }}</span>
              <small v-if="article.price > 0">Basispreis inkl. 19% USt.</small>
              <span class="font-size-2x font-weight-bold" v-if="article.price === 0">Preis auf Anfrage</span>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <Teleport to="body">
      <RequestOfferDialog />
    </Teleport>
</template>

<script>
import {useStore} from "vuex";
import {ref, computed} from "vue";
import {call} from "io";
import CartPlus from "components/Icons/CartPlus";
import Printer from "components/Icons/Printer";
import RequestOfferDialog from "components/RequestOfferDialog";
import SupportBox from "./SupportBox";

export default {
  name: "ConfigurationOverview",
  props: {
    isSticky: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    SupportBox,
    StockDeliveryStatus: {
      template: '#wnmProductConfiguratorStockDeliveryStatus',
    },
    MobileExpertInfo: {
      template: '#wnmProductConfiguratorMobileOverviewExpertInfo',
    },
    MobileExpertBottomInfo: {
      template: '#wnmProductConfiguratorMobileOverviewExpertBottomInfo'
    },
    RequestOfferDialog,
    Printer,
    CartPlus,
  },

  setup() {
    const store = useStore();

    const configuredItems = computed(() => store.getters.getConfiguredItems);

    const totalPrice = computed(() => configuredItems.value.reduce((curr, item) => {
      if (item.isArticle) {
        return curr + (item.netPrice * store.state.currentConfiguration.cartMultiplier);
      }
      return curr + (item.price * store.state.currentConfiguration.cartMultiplier);
    }, 0));

    function showMobile () {
      return (screen.width <= 400)
    }

    return {
      isMobile: showMobile(),
      cartMultiplier: computed({
        get() {
          return store.state.currentConfiguration.cartMultiplier;
        },
        set(value) {
          store.commit('UPDATE_CART_MULTIPLIER', value)
        }
      }),
      configuredItems,
      totalPrice,
      mobileHelpSectionOpen: ref(false),
      isOpen: ref(false),
      article: store.state.article,
      jtlToken: store.state.jtlToken,

      addToCart() {
        const form = document.querySelector('#wnmProductConfigurationOverview');
        form.submit();
      },

      async increaseConfiguredItemQuantity(item) {
        await store.dispatch('updateConfigurationItem', {
          id: item.id,
          quantity: item.quantity + 1
        });
      },
      async decreaseConfiguredItemQuantity(item) {
        await store.dispatch('updateConfigurationItem', {
          id: item.id,
          quantity: item.quantity - 1
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.request-offer-button,
.add-to-cart-button {
  border-radius: 24px;
}

.add-to-cart-button {
  border: 1px solid #00a2f8;
}

.configuration-overview {
  position: sticky;
  top: 0;
  z-index: 1;
}

.configuration-overview-table:not(.configuration-overview-table--mobile) {
  display: block;
  max-height: 400px;
  overflow-y: auto;

  border-bottom: 1px solid #ECECEC;
  padding-bottom: 8px;
  margin-bottom: 8px;

  .configuration-overview-table-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .configuration-overview-table-row .configuration-overview-table-col:first-child {
    max-width: 188px;
  }
}

.configuration-overview-cartMultiplier-wrapper {
  max-width: 33%;
}

.configuration-overview-cartMultiplier {
  max-height: 32px;
  background-color: #F2F2F2;
  border: none;
  font-size: 16px;
  color: #000;
  font-weight: bold;
  padding: 6px 16px;
  border-radius: 16px;
}

.configuration-overview-header {
  border-bottom: 1px solid #ECECEC;
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.configuration-overview-title {
  font-size: 16px;
  font-weight: bold;
  color: #000;
}

.mobile {

  bottom: 0;
  left: 0;
  right: 0;
}

.mobile--open {

  top: 0;

  .stock-delivery-status--label {
    font-weight: bold;
  }

  .configuration-overview--controls {
    position: absolute;
    bottom: 0;
    max-height: 75px;
    left: 0;
    right: 0;
  }

  .configuration-overview {
    overflow-y: scroll;
    overflow-x: hidden;

    max-height: calc(100% - 75px);
  }
}

.configuration-overview--separator {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
}

.configuration-overview-table--mobile {
  .configuration-overview-table-row {
    .configuration-overview-table-col {
      padding-bottom: 10px;
      padding-top: 10px;

      &:first-child {
        width: 75%;
      }

      &:last-child {
        width: 25%;
        text-align: right;
      }
    }
  }
}

</style>